var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M9.7,9.6V8.1L9.2,7V6.7c0-0.1-0.1-0.2-0.2-0.2H8.2C8,6.6,8,6.7,8,6.7V7l0,0l0,0l1.5,1.1l-2,1.4l0,0.1l1.9-1.4 L8.2,9.8h0.3l1.1-1.5L9.7,9.6L9.7,9.6z M9.1,7L9.5,8L8.2,7H9.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M4.3,16.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7C4,16,4.3,16.3,4.3,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M4.1,16.7c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5C3.9,16.2,4.1,16.5,4.1,16.7z "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 5.4,
    cy: 16.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78909C"
    },
    cx: 5.4,
    cy: 16.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 16.5,
    style: {
      fill: "#000"
    },
    width: 4.1,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.7,16.7c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7 C18.3,16,18.7,16.3,18.7,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M18.5,16.7c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5C18.2,16.2,18.5,16.5,18.5,16.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 19.8,
    cy: 16.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78909C"
    },
    cx: 19.8,
    cy: 16.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 16.5,
    style: {
      fill: "#000"
    },
    width: 4.1,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 7.7,
    cy: 16.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#78909C"
    },
    cx: 7.7,
    cy: 16.7,
    r: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.2,16.7c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7C9.9,16,10.2,16.3,10.2,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M10,16.7c0,0.3-0.2,0.5-0.5,0.5S9.1,17,9.1,16.7c0-0.3,0.2-0.5,0.5-0.5C9.8,16.2,10,16.5,10,16.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.6,
    y: 16.5,
    style: {
      fill: "#000"
    },
    width: 4.1,
    height: 0.4
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,10.1v0.7h0h10v-0.7H1.1C1.1,10.1,1,10.1,1,10.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4,10c-0.5-0.3-1.4-0.4-2.1-0.5c0,0.4-0.3,0.7-0.7,0.7h-8.1v0.7h11.2h0.1C22.9,10.5,22.8,10.1,22.4,10z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M1.2,9.5C1.1,9.5,1,9.6,1,9.6v0.5c0,0,0.1,0,0.1,0H11V9.5H1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.3,9.5c-0.4,0-0.7,0-1,0h-7.7v0.7h8.1C20,10.1,20.3,9.8,20.3,9.5z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1,15c-0.2,0-0.4-0.2-0.4-0.4v-2.2c0-0.2,0.2-0.4,0.4-0.4H11V11H1v5.4c0,0.2,0.1,0.3,0.3,0.3H11V15H2.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4,11.3h2.3v-0.5l0,0V11H11.5v1.1h7.7c0.2,0,0.4,0.2,0.4,0.4v2.2c0,0.2-0.2,0.4-0.4,0.4h-7.7v1.7H16V16 c0-0.1,0.1-0.2,0.2-0.2h1.5c0.1,0,0.2,0.1,0.2,0.2v0.7h4.8v-1.5h-2.3c-0.2,0-0.4-0.2-0.4-0.4v-3.3C20.1,11.4,20.2,11.3,20.4,11.3 z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.8,
    style: {
      fill: "#000"
    },
    width: 11.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10.8,
    style: {
      fill: "#000"
    },
    width: 10,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.2,15c0.2,0,0.4-0.2,0.4-0.4v-2.2c0-0.2-0.2-0.4-0.4-0.4h-7.7V15H19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M2.1,12.1c-0.2,0-0.4,0.2-0.4,0.4v2.2c0,0.2,0.2,0.4,0.4,0.4H11v-2.9H2.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#78909C"
    },
    points: "11,9.6 11,10.8 11,11 11,12.1 11,15 11,16.7 11.5,16.7 11.5,15 11.5,12.1 11.5,11 11.5,10.8  11.5,9.6  "
  }), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,14.7v-2.3c0-0.2,0.1-0.4,0.4-0.4h2.1v-0.8h-2.3c-0.2,0-0.4,0.2-0.4,0.4v3.3c0,0.2,0.2,0.4,0.4,0.4 h2.3V15h-2.1C20.4,15,20.3,14.9,20.3,14.7z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.6,12.1c-0.2,0-0.4,0.1-0.4,0.4v2.3c0,0.2,0.1,0.4,0.4,0.4h2.1v-2.9L20.6,12.1L20.6,12.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 11.2,
    y: 9.6,
    style: {
      fill: "#000"
    },
    width: 0.2,
    height: 7.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M19.2,15.8H19c-0.2,0-0.3,0.1-0.3,0.3v0.6H23v-0.4l-3.6-0.2L19.2,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78909C"
    },
    d: "M22.7,15.8h-3.6V16c0,0.1,0.1,0.2,0.2,0.2H23v-0.2C23,15.9,22.9,15.8,22.7,15.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram);
export default __webpack_public_path__ + "static/media/tram.e3bf50b92964abd0a63abe95eeed87eb.svg";
export { ForwardRef as ReactComponent };